import { registerComponent } from "helpers";

registerComponent(
  "back-to-top",
  class BackToTop extends HTMLElement {
    constructor() {
      super();
      this.lastScrollPosition = 0;
      this.onScrollHandler = this.handleScroll.bind(this);
    }

    connectedCallback() {
      this.link = this.querySelector("a");

      if (
        document.documentElement.offsetHeight /
          document.documentElement.clientHeight <
        4
      ) {
        return;
      }

      window.addEventListener("scroll", this.onScrollHandler, false);
    }

    disconnectedCallback() {
      if (this.link) {
        window.removeEventListener("scroll", this.onScrollHandler);
      }
    }

    handleScroll() {
      if (!this.link) {
        return;
      }

      const currentScrollPosition = window.pageYOffset;

      if (
        currentScrollPosition < this.lastScrollPosition &&
        currentScrollPosition > 100
      ) {
        this.link.setAttribute("back-to-top-visible", "true");
        this.link.removeAttribute("aria-hidden");
      } else {
        this.link.setAttribute("back-to-top-visible", "false");
        this.link.setAttribute("aria-hidden", "true");
      }

      this.lastScrollPosition = currentScrollPosition;
    }
  }
);
